<template>
  <div>
    <el-submenu :index="dataList.id.toString()">
      <template slot="title">
        <i :class="dataList.icon"></i>
        <span>{{dataList.name}}</span>
      </template>
      <template v-for="item in dataList.children">
        <router-link :to="item.url" :key="item.id" v-if="item.children.length===0">
          <el-menu-item class="subitem" :index="item.id.toString()" v-if="!hideMenu || (hideMenu && item.id!='31' && item.id!='32' && item.id!='34')">
            <i :class="item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </router-link>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import { httpAgent } from "@/api/ajax"
export default {
  props: {
    dataList: [Array, Object]
  },
  data () {
    return {
      hideMenu:false
    }
  },
  mounted () {
    
  },
  created(){
    this.getDomainInfo();
  },
  methods: {
    //获取当前域名企业信息
    getDomainInfo () {
      httpAgent({
        url: `${location.hostname == 'localhost' ? 'http://gateway.eline56.test' : ''}/agent/config/preGet`,
        method: "get",
      }).then((res) => {
        if (res.id) {
          this.hideMenu = res.hideMenu;
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
// .el-submenu {
//   width: 165px;
//   .el-menu-item {
//     padding: 0 16px;
//     .iconfont {
//       margin-right: 8px;
//     }
//   }
//   /deep/.el-submenu__title {
//     padding: 0 8px;
//   }
// }
</style>